import React from 'react';
import PropTypes from 'prop-types';
// import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import {
  // Box,
  Flex,
  VStack,
  HStack,
  Text,
  Button,
  Link,
  Divider,
  Badge,
} from '@chakra-ui/react';

function isTimeExpired(timeString) {
  try {
    const inputTime = new Date(timeString);

    if (isNaN(inputTime)) {
      throw new Error('Invalid time string format');
    }

    const currentTime = new Date();
    return inputTime < currentTime;
  } catch (error) {
    console.error(error.message);
    return false;
  }
}

function daysFromNow(timeString) {
  try {
    const targetDate = new Date(timeString);
    if (isNaN(targetDate)) {
      throw new Error('Invalid time string format');
    }

    const currentDate = new Date();
    const differenceInMs = targetDate - currentDate;

    const days = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));

    return days;
  } catch (error) {
    console.error(error.message);
    return null;
  }
}

const SubscriptionStatus = ({
  subscriptionId,
  planName,
  isFreePlan,
  status,
  trialEndDate,
  nextBillingTime,
  expiredDate,
  price,
  interval,
  discountInfo,
}) => {
  const navigate = useNavigate();
  const onViewHistory = () => {};
  const onCancel = () => {};
  const onChangePlan = () => {
    console.log('subscriptionId: ', subscriptionId);
  };
  const onSubscribe = () => {
    navigate('/pricing');
  };

  function getStatusColor(status) {
    if (status === 'Active') return 'green';
    if (status === 'Trialing') return 'yellow';
    return 'red';
  }

  return (
    <Flex>
      <VStack align="start" spacing={4}>
        {isFreePlan ? (
          // Free Plan Section
          <>
            <Text fontSize="lg" fontWeight="bold" color="gray.700">
              Current Plan: Free Trial
            </Text>
            <Text fontSize="md" color="gray.600">
              {daysFromNow(trialEndDate) > 0
                ? `Free trial ends in ${daysFromNow(trialEndDate)} day${
                    daysFromNow(trialEndDate) > 1 ? 's' : ''
                  }.`
                : 'Your free trial has ended.'}
            </Text>
            <Button colorScheme="green" onClick={onSubscribe}>
              Subscribe Now
            </Button>
            {daysFromNow(trialEndDate) > 0 && (
              <Text fontSize="sm" color="gray.600">
                Note: Unused free trial days will still remain after
                subscribing.
              </Text>
            )}
          </>
        ) : (
          // Paid Plan Section
          <>
            <HStack spacing={2}>
              <Text fontSize="lg" fontWeight="bold" color="gray.700">
                Current Plan: {planName}
              </Text>
              <Badge colorScheme={getStatusColor(status)}>{status}</Badge>
            </HStack>
            {nextBillingTime && (
              <Text
                fontSize="md"
                color={isTimeExpired(nextBillingTime) ? 'red.500' : 'gray.600'}
              >
                Next Billing: {new Date(nextBillingTime).toLocaleString()}
              </Text>
            )}
            {expiredDate && (
              <Text fontSize="md" color="red.500">
                Expired: {new Date(expiredDate).toLocaleString()}
              </Text>
            )}
            <Text fontSize="md" color="gray.600">
              Price: ${price} per {interval}
            </Text>
            {discountInfo && (
              <Text fontSize="sm" color="gray.500">
                {discountInfo}
              </Text>
            )}
            <Divider />
            <HStack justify="space-between" w="full">
              <Link
                color="blue.500"
                fontSize="sm"
                onClick={onViewHistory}
                cursor="pointer"
              >
                View Payment History
              </Link>
              <HStack spacing={3}>
                <Button
                  colorScheme="red"
                  variant="outline"
                  size="sm"
                  onClick={onCancel}
                >
                  Cancel
                </Button>
                <Button colorScheme="blue" size="sm" onClick={onChangePlan}>
                  Change Plan
                </Button>
              </HStack>
            </HStack>
          </>
        )}
      </VStack>
      {/* </Box> */}
    </Flex>
  );
};

SubscriptionStatus.propTypes = {
  subscriptionId: PropTypes.string.isRequired,
  planName: PropTypes.string,
  status: PropTypes.string.isRequired,
  isFreePlan: PropTypes.bool.isRequired,
  trialEndDate: PropTypes.string,
  nextBillingTime: PropTypes.string,
  expiredDate: PropTypes.string,
  price: PropTypes.string,
  interval: PropTypes.string,
  discountInfo: PropTypes.string,
};

export default SubscriptionStatus;
